export default "__VITE_ASSET__BIGqhZXM__"